import { computed, defineComponent, nextTick, reactive, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { withLoading } from '@hems/component';
import { UserReportService } from '@hems/service';
import { getOverviewOptions } from '@hems/user/src/containers/report/analysis/chartOptions';
import { getOverviewCardData } from '@hems/user/src/containers/report/cardFunctions';
import { getOverviewData } from '@hems/user/src/containers/report/chartFunctions';
import { useLocale } from '@hems/util';
import { EnergyBalanceNavigator, EnergyBalanceOverview, GraphChart } from '@/components';
export default defineComponent({
    name: 'AnalysisContainer',
    components: {
        EnergyBalanceNavigator,
        EnergyBalanceOverview,
        GraphChart,
    },
    props: {
        siteConfigurationInfo: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const { t } = useI18n();
        const store = useStore();
        const state = reactive({
            data: {
                generation: [],
                consumption: [],
                feedin: [],
                demand: [],
                charge: [],
                discharge: [],
            },
            responseData: null,
            cardData: null,
            showChart: false,
            showCard: false,
        });
        const defaultBaseDeviceInfo = {
            device_id: '',
            site_id: 0,
            timezone_id: '',
            product_model_nm: '',
        };
        const defaultReportIntervalResult = {
            gen_data: [],
            gen_co2: [],
            gen_kwh: { origin: 0, convertedEnergy: '', unit: '' },
            con_data: [],
            con_co2: [],
            con_kwh: { origin: 0, convertedEnergy: '', unit: '' },
            core_data: [],
            core_co2: [],
            core_kwh: { origin: 0, convertedEnergy: '', unit: '' },
            btc_data: [],
            btc_co2: [],
            btc_kwh: { origin: 0, convertedEnergy: '', unit: '' },
            btd_data: [],
            btd_co2: [],
            btd_kwh: { origin: 0, convertedEnergy: '', unit: '' },
            feedin_data: [],
            feedin_co2: [],
            feedin_kwh: { origin: 0, convertedEnergy: '', unit: '' },
            demand_data: [],
            demand_co2: [],
            demand_kwh: { origin: 0, convertedEnergy: '', unit: '' },
            soc_data: [],
            colec_time: [],
        };
        const { intlFormatLocale } = useLocale();
        const baseDeviceInfo = computed(() => store.state.device.baseDeviceInfo ?? null);
        const siteConfiguration = computed(() => props.siteConfigurationInfo ?? null);
        const options = computed(() => getOverviewOptions(state.data, t, intlFormatLocale.value, siteConfiguration.value?.hasPV ?? false, siteConfiguration.value?.hasESS ?? false));
        const service = new UserReportService(window.axiosInstance.axios);
        const loadData = withLoading(async () => {
            try {
                const { status, result } = await service.getOverview(baseDeviceInfo.value ?? defaultBaseDeviceInfo);
                if (status === 'ok') {
                    state.responseData = result;
                    state.cardData = getOverviewCardData(intlFormatLocale.value, result, t, siteConfiguration.value?.hasPV ?? false, siteConfiguration.value?.hasESS ?? false);
                    state.data = getOverviewData(result);
                }
            }
            catch (e) {
                console.error(e);
                state.cardData = getOverviewCardData(intlFormatLocale.value, defaultReportIntervalResult, t, siteConfiguration.value?.hasPV ?? false, siteConfiguration.value?.hasESS ?? false);
                state.data = getOverviewData(defaultReportIntervalResult);
            }
            finally {
                state.showCard = true;
                nextTick(() => (state.showChart = true));
            }
        });
        function rerenderDataGrid() {
            state.showChart = false;
            nextTick(() => (state.showChart = true));
        }
        watch(() => intlFormatLocale.value, () => {
            rerenderDataGrid();
            state.cardData = getOverviewCardData(intlFormatLocale.value, state.responseData ?? null, t, siteConfiguration.value?.hasPV ?? false, siteConfiguration.value?.hasESS ?? false);
        });
        loadData();
        return {
            state,
            options,
            siteConfiguration,
            intlFormatLocale,
        };
    },
});
